module.exports = __webpack_public_path__ + "static/img/04.4f0d2a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news22/04.png
// module id = jyG+
// module chunks = 1